module.exports = __webpack_public_path__ + "static/media/pa-icon.17c41db7.svg";